<template>
  <label
    class="btn w-100 btn-white"
    :class="{ active: appIsEnabled, disabled: app.disabled }"
    @click="!app.disabled && $emit('toggle', app)"
  >
    {{ app.title }}
    <span v-if="app.disabled" class="badge bg-secondary-soft ms-1">Coming soon</span>
  </label>
</template>

<script>
export default {
  name: 'PaymentsHubAppSelector',
  props: {
    app: {
      type: Object,
      required: true,
    },
    enabledApps: {
      type: Array,
      required: true,
    },
  },
  computed: {
    appIsEnabled() {
      return this.enabledApps.includes(this.app.name)
    },
  },
}
</script>
